import { ActivePushTopic, PushTopic } from './types';

export const UPDATE_PUSH_STATUS = 'UPDATE_PUSH_STATUS';

export const updatePushStatus = (
    status:
        | {
              supported: boolean;
              permission: PermissionState;
          }
        | {
              inProgress?: boolean;
              topics?: PushTopic[];
              topicsActive?: ActivePushTopic[];
          },
) => ({ type: UPDATE_PUSH_STATUS, payload: status });
